import axios from 'axios';
import { useEffect, useState } from 'react';
import { tl } from './inlineI18n';

// Soket / taş / rune yapılandırması (sunucudan bir kez alınır, bellekte tutulur).
let cached = null;
let pending = null;

export const loadSocketConfig = async (force = false) => {
  if (cached && !force) return cached;
  if (pending && !force) return pending;
  pending = axios
    .get('/api/sockets/config')
    .then((res) => {
      if (res.data?.success) cached = res.data;
      return cached;
    })
    .catch(() => cached)
    .finally(() => {
      pending = null;
    });
  return pending;
};

export const useSocketConfig = () => {
  const [cfg, setCfg] = useState(cached);
  useEffect(() => {
    let alive = true;
    loadSocketConfig().then((c) => {
      if (alive && c) setCfg(c);
    });
    return () => {
      alive = false;
    };
  }, []);
  return cfg;
};

export const isEnglish = () => tl(false, true);

export const stoneByOtherId = (cfg, otherId) => {
  if (!cfg || !otherId) return null;
  for (const stone of cfg.stones || []) {
    const level = otherId - stone.baseId;
    if (level >= 0 && level < (stone.values?.length || 4)) return { stone, level };
  }
  return null;
};

export const stoneImageUrl = (stone, level) =>
  `${process.env.PUBLIC_URL || ''}/image/others/gems/${stone.key}_${level + 1}.png`;

export const stoneDisplayName = (cfg, stone, level) => {
  const en = isEnglish();
  const names = (en ? cfg?.levelNamesEn : cfg?.levelNames) || [];
  return `${names[level] || ''} ${en ? stone.nameEn : stone.name}`.trim();
};

export const effectLabel = (cfg, effect) => {
  const en = isEnglish();
  const s = (cfg?.stones || []).find((x) => x.effect === effect);
  if (!s) return effect;
  return en ? s.labelEn : s.label;
};

const stoneToken = (stone) => (stone.kind === 'rune' ? `rune:${stone.key}` : stone.color);

export const tokenLabel = (cfg, token) => {
  const en = isEnglish();
  if (token.startsWith('rune:')) {
    const s = (cfg?.stones || []).find((x) => x.kind === 'rune' && x.key === token.slice(5));
    return s ? (en ? s.nameEn : s.name) : token;
  }
  const s = (cfg?.stones || []).find((x) => x.kind === 'gem' && x.color === token);
  return s ? (en ? s.nameEn : s.name) : token;
};

const patternMatches = (tokens, pattern) => {
  if (!pattern?.length || pattern.length > tokens.length) return false;
  for (let start = 0; start + pattern.length <= tokens.length; start += 1) {
    if (pattern.every((p, j) => tokens[start + j] && tokens[start + j] === p)) return true;
  }
  return false;
};

// Sunucudaki socketBonuses ile aynı hesap: taş bonusları + eşleşen kombinasyonlar.
export const computeSocketBonuses = (cfg, slots) => {
  const rows = [];
  const tokens = (slots || []).map((id) => {
    const found = stoneByOtherId(cfg, id);
    if (!found) return '';
    rows.push({ effect: found.stone.effect, value: found.stone.values[found.level] });
    return stoneToken(found.stone);
  });
  const combos = (cfg?.combos || []).filter((c) => patternMatches(tokens, c.pattern));
  return { rows, combos };
};
